var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgConnectedLovingIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 68,
    viewBox: "0 0 75 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.5515 66.2324C59.4721 66.2324 73.9995 51.704 73.9995 33.7822C73.9995 15.8605 59.4721 1.33203 41.5515 1.33203C23.631 1.33203 9.10352 15.8605 9.10352 33.7822C9.10352 51.704 23.631 66.2324 41.5515 66.2324Z",
    fill: "white",
    stroke: "#231F20",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9062 18.241C22.9062 18.241 24.8763 13.246 31.5282 13.2344C31.5282 13.2344 37.0907 13.2344 39.362 18.241C39.362 18.241 32.0265 12.7476 22.9178 18.241H22.9062Z",
    fill: "#231F20"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M60.5925 18.241C60.5925 18.241 58.6225 13.246 51.9706 13.2344C51.9706 13.2344 46.4081 13.2344 44.1367 18.241C44.1367 18.241 51.4723 12.7476 60.5809 18.241H60.5925Z",
    fill: "#231F20"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7307 39.0544C16.6365 33.7117 10.68 39.7498 10.68 39.7498C10.68 39.7498 4.72347 33.7117 1.62932 39.0544C-1.91678 45.1736 10.68 51.5941 10.68 51.5941C10.68 51.5941 23.2884 45.1736 19.7307 39.0544Z",
    fill: "#FF0812",
    stroke: "#231F20",
    strokeWidth: 1.3,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M31.3085 26.7703C34.2636 26.7703 36.674 29.2736 36.674 32.3564C36.674 32.7157 36.5465 33.0286 36.477 33.3647C37.462 33.8051 38.4702 34.3266 39.5132 35.0683C39.5132 20.7207 32.6644 20.3151 31.3201 20.373C29.9758 20.3151 23.127 20.7207 23.127 35.0683C23.127 35.0683 24.251 34.06 26.1284 33.2256C26.082 32.9243 25.9546 32.6577 25.9546 32.3564C25.9546 29.2736 28.3534 26.7703 31.3201 26.7703H31.3085Z",
    fill: "white",
    stroke: "#231F20",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M36.4774 33.3639C36.5353 33.0278 36.6744 32.7149 36.6744 32.3556C36.6744 29.2728 34.2756 26.7695 31.3089 26.7695C28.3422 26.7695 25.9434 29.2728 25.9434 32.3556C25.9434 32.6685 26.0708 32.9351 26.1172 33.2248C28.5044 32.1702 32.1432 31.4285 36.4774 33.3523V33.3639Z",
    fill: "#231F20",
    stroke: "#231F20",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M52.1913 26.7703C55.1464 26.7703 57.5568 29.2736 57.5568 32.3564C57.5568 32.7157 57.4294 33.0286 57.3598 33.3647C58.3449 33.8051 59.3531 34.3266 60.396 35.0683C60.396 20.7207 53.5472 20.3151 52.2029 20.373C50.8586 20.3151 44.0098 20.7207 44.0098 35.0683C44.0098 35.0683 45.1339 34.06 47.0112 33.2256C46.9649 32.9243 46.8374 32.6577 46.8374 32.3564C46.8374 29.2736 49.2362 26.7703 52.2029 26.7703H52.1913Z",
    fill: "white",
    stroke: "#231F20",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M57.3602 33.3639C57.4181 33.0278 57.5572 32.7149 57.5572 32.3556C57.5572 29.2728 55.1583 26.7695 52.1917 26.7695C49.225 26.7695 46.8262 29.2728 46.8262 32.3556C46.8262 32.6685 46.9536 32.9351 47 33.2248C49.3872 32.1702 53.0261 31.4285 57.3602 33.3523V33.3639Z",
    fill: "#231F20",
    stroke: "#231F20",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M31.4004 46.7383C31.4004 46.7383 41.7374 57.4468 51.7036 46.7383H31.4004Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M31.4004 46.7383C31.4004 46.7383 41.7374 57.4468 51.7036 46.7383",
    stroke: "#231F20",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConnectedLovingIcon);
export default __webpack_public_path__ + "static/media/connected-loving-icon.413ff99983adbdf400004fb34cd4c3e5.svg";
export { ForwardRef as ReactComponent };